import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import WideFormatPrinterCostsWrapper from "@components/layouts/wideformatprintercostsWrapper";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <WideFormatPrinterCostsWrapper>
            <section className=" max-w-7xl mx-auto ">
                <PrivacyPolicy
                    domain="WideFormatPrinterCosts.com"
                    category="Wide Format Printers"
                />
            </section>
        </WideFormatPrinterCostsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
